import React from "react";
import moment from "moment";
import { IconButton, Typography } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import useStyles from "./styles";

const ListHeader = ({ onRefresh }) => {
  const classes = useStyles();
  return (
    <div className={classes.listHeader}>
      <Typography className={classes.today} variant="subtitle2">
        {moment().format("dddd, MMMM DD, Y")}
      </Typography>
      <div className={classes.refreshButton}>
        <IconButton onClick={onRefresh} aria-label="Refresh">
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default ListHeader;
